import { MapPin, Phone, Mail, Leaf } from "lucide-react";
import { CONTACT } from "@/data/cabanas";

export const Footer = () => {
  return (
    <footer
      id="contato"
      data-testid="site-footer"
      className="bg-[#1A2421] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-10 flex items-center justify-center bg-[#2C5545]">
              <Leaf size={20} strokeWidth={1.5} />
            </span>
            <span className="text-lg font-bold tracking-tight">
              Cabanas da Quinta
            </span>
          </div>
          <p className="text-sm leading-relaxed text-[#C8C2B5] max-w-xs">
            Hospedagem rural em meio às plantações de morango de São José dos
            Pinhais. Aconchego, natureza e gastronomia em um só lugar.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#C8C2B5] mb-5">
            Contato
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 flex-shrink-0 text-[#C05A44]" strokeWidth={1.5} />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 flex-shrink-0 text-[#C05A44]" strokeWidth={1.5} />
              <a
                href={`https://wa.me/${CONTACT.phoneIntl.replace("+", "")}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="hover:text-[#C05A44] transition-colors"
              >
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 flex-shrink-0 text-[#C05A44]" strokeWidth={1.5} />
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="hover:text-[#C05A44] transition-colors break-all"
              >
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#C8C2B5] mb-5">
            Horários
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <span className="text-[#C8C2B5]">Check-in: </span>
              <span className="font-semibold">a partir das 12h00</span>
            </li>
            <li>
              <span className="text-[#C8C2B5]">Check-out: </span>
              <span className="font-semibold">até as 17h00</span>
            </li>
            <li className="pt-4">
              <span className="text-[#C8C2B5]">CNPJ: </span>
              <span className="font-mono text-xs">{CONTACT.cnpj}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#2C5545]/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#C8C2B5]">
            © {new Date().getFullYear()} Cabanas da Quinta. Todos os direitos
            reservados.
          </p>
          <p className="text-xs text-[#C8C2B5]">
            Feito com cuidado em meio à natureza paranaense.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
